import { useState, useCallback } from "react";

import { Nullable } from "config";

const useLocalStorage = <T>(
  key?: string,
  initialValue?: T
): [Nullable<T>, (value: T) => void] => {
  const [storedValue, setStoredValue] = useState<Nullable<T>>(() => {
    try {
      if (!key) {
        return null;
      }

      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue ?? null;
    } catch (error) {
      console.log(error);
      return null;
    }
  });

  const handleValueChange = useCallback(
    (value: T) => {
      try {
        if (!key) {
          return;
        }

        setStoredValue(value);
        if (value === null) {
          localStorage.removeItem(key);
        } else {
          localStorage.setItem(key, JSON.stringify(value));
        }
      } catch (error) {
        console.log(error);
      }
    },
    [key]
  );

  return [storedValue, handleValueChange];
};

export default useLocalStorage;
